import React from "react";

import { Row, Col, Table, Button } from "react-bootstrap";
import { Margin, wrapArray } from "shared/utils";
import routes from "startups/routes";

import { Money, ConfirmationModal } from "shared/components";

import OrderUnitImage from "shared/order-units/OrderUnitImage";

const OrderUnitsList = props => {
  const { orderUnits, removeOrderUnitFn } = props;

  return (
    <div className="order-units-list order-units-list-overview">
      {orderUnits.map(orderUnit => {
        return (
          <OrderUnitsListRow
            orderUnit={orderUnit}
            key={`ou-${orderUnit.id}`}
            removeOrderUnitFn={removeOrderUnitFn}
          />
        );
      })}
    </div>
  );
};

class OrderUnitsListRow extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  openConfirmDeleteModal() {
    this.setState({
      confirmDeleteModalVisible: true,
    });
  }

  closeConfirmDeleteModal() {
    this.setState({
      confirmDeleteModalVisible: false,
    });
  }

  removeOrderUnit(event) {
    event.preventDefault();
    this.props.removeOrderUnitFn(this.props.orderUnit.id);
    this.closeConfirmDeleteModal();
  }

  findProductForOrderUnitProduct(orderUnitProduct, orderUnit) {
    return wrapArray(orderUnit.products).find(
      product => parseInt(product.id, 10) === orderUnitProduct.productId,
    );
  }

  render() {
    const { props } = this;
    const { orderUnit } = props;
    const orderUnitsProducts = wrapArray(orderUnit.orderUnitsProducts);
    const firstOrderUnitProduct = orderUnitsProducts[0];
    const firstProduct =
      firstOrderUnitProduct &&
      this.findProductForOrderUnitProduct(firstOrderUnitProduct, orderUnit);

    return (
      <div id={`order-unit-${orderUnit.id}`}>
        <ConfirmationModal
          title="Möchtest Du diese Bestelleinheit wirklich löschen?"
          primaryActionCaption="Ja, ich will!"
          primaryActionFn={this.removeOrderUnit.bind(this)}
          visible={this.state.confirmDeleteModalVisible}
          closeFn={this.closeConfirmDeleteModal.bind(this)}
        />
        <p className="order-unit-heading">
          <a href={routes.startupsOrderUnitPath(orderUnit.id)}>
            {orderUnit.name}
          </a>
        </p>

        <Row>
          <Col xs={12} sm={1} className="order-units-list-item-left">
            <OrderUnitImage orderUnit={orderUnit} />
            {orderUnit.ean && (
              <div>
                <strong>EAN {orderUnit.ean}</strong>
              </div>
            )}
          </Col>
          <Col xs={12} sm={11} className="order-units-list-item-right">
            <Table striped bordered hover>
              <colgroup span="3" />
              <colgroup span="6" />
              <thead>
                <OrderUnitsListFirstTableHeader />
                <OrderUnitsListSecondTableHeader />
              </thead>
              <tbody>
                {firstOrderUnitProduct && (
                  <OrderUnitsListTableFirstRow
                    orderUnit={orderUnit}
                    firstOrderUnitProduct={firstOrderUnitProduct}
                    firstProduct={firstProduct}
                  />
                )}
                {orderUnitsProducts.slice(1).map(oup => {
                  return (
                    <OrderUnitsListTableAdditionalRow
                      key={`oup-${oup.id}`}
                      orderUnitProduct={oup}
                      product={this.findProductForOrderUnitProduct(
                        oup,
                        orderUnit,
                      )}
                    />
                  );
                })}
              </tbody>
            </Table>

            <If condition={this.props.orderUnit.deletable}>
              <Button
                className="btn btn-secondary pull-right"
                onClick={this.openConfirmDeleteModal.bind(this)}
              >
                Löschen
              </Button>
            </If>
          </Col>
        </Row>
      </div>
    );
  }
}

const OrderUnitsListFirstTableHeader = () => {
  return (
    <tr>
      <th colSpan="4" scope="colgroup">
        Bestelloption
      </th>
      <th colSpan="3" scope="colgroup">
        <span>Verkaufseinheit</span>
      </th>
    </tr>
  );
};

const OrderUnitsListSecondTableHeader = () => {
  return (
    <tr className="order-units-table-header-overview">
      <th>
        <span title="Einkaufspreis">EK (Netto)</span>
      </th>
      <th>Pfand (Netto)</th>
      <th>
        Anzahl <span title="Verkaufseinheiten">VKE</span>
      </th>
      <th>
        Anzahl <span title="Verkaufseinheiten">VKE</span> / Sorte
      </th>
      <th>
        <span title="Einkaufspreis">EK (Netto)</span>
      </th>
      <th>UVP</th>
      <th>Spanne</th>
    </tr>
  );
};

const OrderUnitsListTableFirstRow = props => {
  const { orderUnit, firstOrderUnitProduct, firstProduct } = props;
  const firstProductMargin = new Margin(
    firstProduct.vat,
    firstProduct.purchasingPrice,
    firstProduct.rrp,
  );

  return (
    <tr>
      <td>
        <Money cents={orderUnit.netPriceCents} />
      </td>
      <td>
        {orderUnit.shippingUnitDepositValueCents ? (
          <Money cents={orderUnit.shippingUnitDepositValueCents} />
        ) : (
          <em>Kein Pfand</em>
        )}
        {orderUnit.shippingUnitDepositValueCents ? (
          <div>{`(${orderUnit.shippingUnitDepositType})`}</div>
        ) : (
          ""
        )}
      </td>
      <td>{orderUnit.totalProductCount}</td>
      <td>
        {firstOrderUnitProduct.productCount}× {firstProduct.productVariantName}
      </td>
      <td>
        <Money cents={firstProduct.purchasingPriceCents} />
      </td>
      <td>
        <Money cents={firstProduct.rrpCents} />
      </td>
      <td>{firstProductMargin.marginFormatted()}</td>
    </tr>
  );
};

const OrderUnitsListTableAdditionalRow = props => {
  const { orderUnitProduct, product } = props;
  const productMargin = new Margin(
    product.vat,
    product.purchasingPrice,
    product.rrp,
  );

  return (
    <tr>
      <td />
      <td />
      <td />
      <td>
        {orderUnitProduct.productCount}× {product.productVariantName}
      </td>
      <td>
        <Money cents={product.purchasingPriceCents} />
      </td>
      <td>
        <Money cents={product.rrpCents} />
      </td>
      <td>{productMargin.marginFormatted()}</td>
    </tr>
  );
};

export default OrderUnitsList;
